export const toDate = (dStr: string, format: string) => {
  const now = new Date();
  if (format == "h:m") {
    now.setHours(parseInt(dStr.substr(0, dStr.indexOf(":"))));
    now.setMinutes(parseInt(dStr.substr(dStr.indexOf(":") + 1)));
    now.setSeconds(0);
    return now;
  }
  return;
};

export const isTimeInRange = (from: string, to: string) => {
  const timeStampFrom = toDate(from, "h:m");
  const timeStampTo = toDate(to, "h:m");
  const now = new Date();

  return now.getTime() >= timeStampFrom.getTime() &&
    now.getTime() <= timeStampTo.getTime()
    ? true
    : false;
};
